var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import useConfig from '../../context/config.context';
const useFeatureFlagsQuery = () => {
    const { config: { hosts: { serviceFile: serviceFileUrl } } } = useConfig();
    return useQuery({
        queryKey: [serviceFileUrl],
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield fetch(serviceFileUrl);
            return response.json();
        })
    });
};
export default useFeatureFlagsQuery;
//# sourceMappingURL=index.js.map